import {RouteDefinition} from '../../../routes';
import {ControlTypeListScreen} from './ControlTypeListScreen';
import {ControlTypeEditScreen} from './ControlTypeEditScreen';

export const ControlTypeSettingsRoutes: RouteDefinition[] = [
    {
        name: 'KONTROL TİP OLUŞTUR',
        routerLink: '/developer/control-type',
        component: ControlTypeListScreen,
    },
    {
        name: 'KONTROL OLUŞTUR',
        routerLink: '/developer/control-type/edit',
        component: ControlTypeEditScreen,
    },
    {
        name: 'KONTROL DÜZENLE',
        routerLink: '/developer/control-type/edit/:id',
        component: ControlTypeEditScreen,
    },
];
